export const companyType = {
  SP: 'ип',
  LLP: 'тоо',
  JSC: 'ао',
  LLC: 'ооо',
} as const;

export const companyTypeLabel = {
  [companyType.SP]: 'ЖК / ИП',
  [companyType.LLP]: 'ЖШС / ТОО',
  [companyType.JSC]: 'АҚ / АО',
  [companyType.LLC]: 'ЖШҚ / ООО',
};
